import { connect } from 'react-redux';

// Actions
import { getSelfEvaluationList } from './selfEvaluationActions';

// Component
import SelfEvaluation from './SelfEvaluation';
import { getOfficesShortList } from 'custom_modules/Offices/officesActions';
import { getOrganizationMembersList } from 'custom_modules/Projects/projectsActions';

// Store props to map with current state
const mapStateToProps = state => ({
  officeName: state.selfEvaluation.officeName,
  periodStart: state.selfEvaluation.periodStart,
  periodEnd: state.selfEvaluation.periodEnd,
  evaluations: state.selfEvaluation.evaluations,
  evaluationCards: state.selfEvaluation.evaluationCards,
  officesShortList: state.office.officesShortList,
  selfEvaluationListIsLoading: state.selfEvaluation.selfEvaluationListIsLoading,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  memberShortList: state.project.orgMembersList,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getSelfEvaluationList: params =>
    dispatch(getSelfEvaluationList({ ...params })),
  getOfficesShortList: params =>
    dispatch(getOfficesShortList(params)),
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(SelfEvaluation);
